import { generateSkinDefaults } from '@wix/editor-elements-panel';

import type { SiteAssetsSkinParams } from '../TextEffectsShared/TextEffectsShared.skinParams';
import { textEffectsSharedSkin } from '../TextEffectsShared/TextEffectsShared.skinParams';

export const TextEffectsStickerSkin = {
  ...textEffectsSharedSkin,
  'bg-opacity': {
    type: 'ALPHA',
    defaultValue: '1',
  },
  'bg-solid': {
    type: 'COLOR',
    defaultValue: '#000000',
  },
  'outer-stroke': {
    type: 'NUMBER',
    defaultValue: '20',
  },
  'outer-stroke-angle': {
    type: 'CSSString',
    defaultValue: '45deg',
  },
  'outer-stroke-color': {
    type: 'COLOR',
    defaultValue: '#000000',
  },
  'outer-stroke-distance': {
    type: 'NUMBER',
    defaultValue: '0',
  },
  'shadow-color': {
    type: 'COLOR',
    defaultValue: '#000000',
  },
  'shadow-angle': {
    type: 'CSSString',
    defaultValue: '45deg',
  },
  'shadow-blur': {
    type: 'NUMBER',
    defaultValue: '10',
  },
  'shadow-distance': {
    type: 'NUMBER',
    defaultValue: '50',
  },
} as const satisfies SiteAssetsSkinParams;

const TextEffectsStickerSkinDefinitionMap: Record<
  string,
  SiteAssetsSkinParams
> = {
  'wixui.skins.TextEffectsSticker': TextEffectsStickerSkin,
};

export default generateSkinDefaults(TextEffectsStickerSkinDefinitionMap);
